import { taskItemTypes } from 'constants/tasks';
import { taskRegardingValues } from 'pages/Prequal/constants';
import { getDocumentSignSection, getPersonalGuaranteeSignaturesSection } from 'utils/ocaTemplateUtils';
import { SpecialTaskItemType, SpecialTaskItemTypeConfig } from '../types';

export const specialTaskItemTypesConfig: Record<SpecialTaskItemType, SpecialTaskItemTypeConfig> = {
  [taskItemTypes.catFiAddendum]: {
    label: taskRegardingValues.catFiAddedndum,
    regarding: taskRegardingValues.catFiAddedndum,
    assignorNote: 'Please provide a signature for the document.',
    getOcaSection: getDocumentSignSection,
  },
  [taskItemTypes.newSignorAndGuarantorSignature]: {
    label: taskRegardingValues.newSignorAndGuarantorSignature,
    regarding: taskRegardingValues.newSignorAndGuarantorSignature,
    assignorNote: 'Please review credit application and provide signature.',
    getOcaSection: getPersonalGuaranteeSignaturesSection,
  },
};
